import { PaymentMethodType } from "@dewo/app/graphql/types";

export const paymentMethodTypeToString: Record<PaymentMethodType, string> = {
  [PaymentMethodType.METAMASK]: "Metamask",
  [PaymentMethodType.GNOSIS_SAFE]: "Gnosis Safe",
  [PaymentMethodType.UTOPIA]: "Utopia",
  [PaymentMethodType.PHANTOM]: "Phantom Wallet",
  [PaymentMethodType.HIRO]: "Hiro Wallet",
};

export const networkSlugsByPaymentMethodType: Record<
  PaymentMethodType,
  string[]
> = {
  [PaymentMethodType.METAMASK]: [
    "ethereum-mainnet",
    "ethereum-rinkeby",
    "ethereum-goerli",
    "gnosis-chain",
    "polygon-mainnet",
    "sokol-testnet",
    "harmony-mainnet",
    "harmony-testnet",
    "zetachain-athens-2-testnet",
    "arbitrum-mainnet",
    "optimism-mainnet",
    "fuse-mainnet",
    "bsc-mainnet",
    "avalanche-mainnet",
    "fantom-mainnet",
    "aurora-mainnet",
    "conflux-mainnet",
  ],
  [PaymentMethodType.GNOSIS_SAFE]: [
    "ethereum-mainnet",
    "ethereum-rinkeby",
    "gnosis-chain",
    "polygon-mainnet",
    "arbitrum-mainnet",
    "optimism-mainnet",
    "aurora-mainnet",
    "avalanche-mainnet",
    "bsc-mainnet",
  ],
  [PaymentMethodType.PHANTOM]: ["solana-mainnet", "solana-testnet"],
  [PaymentMethodType.HIRO]: ["stacks-mainnet", "stacks-testnet"],
  [PaymentMethodType.UTOPIA]: [
    "ethereum-mainnet",
    "gnosis-chain",
    "polygon-mainnet",
    "avalanche-mainnet",
    "arbitrum-mainnet",
    "optimism-mainnet",
    "bsc-mainnet",
  ],
};
